export default [
  ['vacuum cleaner', 'your socks'],
  ['peach', 'watermelon'],
  ['Ross', 'divorce'],
  ['Homer', 'donuts'],
  // ['joker', 'batsy'],
  ['Scaramouche', 'fandango'],
  ['Peter', 'pan'],
  ['Jango', 'freedom'],
  // ['Kaneda', 'Tetsuo'],
  ['asphalt', 'your knees'],
  ['Mulder', 'believe'],
  ['train', 'railroad'],
  // ['umbrella', 'rain'],
  ['ninja', 'shuriken'],
];



// WEBPACK FOOTER //
// ./src/components/Header2/slogans.js